<script>
import Barlist from '../components/bar-list'
import PedidoFiltro from '../components/pedido-filtro'
import BarGrid from '../components/bar-grid.vue'
import { SysVars } from '../main'
import DevolucaoForm from './varejo-devolucao-form.vue'

export default {
    components:{
        BarGrid,
        Barlist,
        PedidoFiltro,
        DevolucaoForm
    },

    data(){
        return{
            pedv:this.$store.getters.getPedvDev,
            query:{
                codusuario: null,
                codequipe: null,
                text:null,
                after: null,
                before: null,
                codstatus: null,
                showForm: false
            },
            codvdevol: 0,
            showForm: false,
            crud: ''
        }
    },

    methods:{
        loadData(){
            let param = {}
            param.query = ''

            if (this.query.text)
              param.query = param.query + 'text=' + `${this.query.text}` + '&'
            if (this.query.after)
              param.query = param.query + 'after=' + this.query.after + '&'
            if (this.query.before)
              param.query = param.query + 'before=' + this.query.before + '&'
            if (this.query.codusuario)
              param.query = param.query + 'usuario=' + this.query.codusuario + '&'
            if (this.query.codequipe)
              param.query = param.query + 'equipe=' + this.query.codequipe + '&'
            if (this.query.codstatus)
              param.query = param.query + 'codstatus=' + this.query.codstatus + '&'
            if (this.statusQuery)
              param.query = param.query + this.statusQuery + '&'

            param.query = param.query.trim('&')
            this.$store.dispatch('loadvDevolList', param)

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })

        },

        handleAutorizaNF(path){
            return this.$router.push('/nf/' + path + '?tipo=devolucao')
        },

        changeFiltroTexto(value){
            this.query.text = value.toUpperCase()
            this.query.after = null
            this.query.before = null
            this.loadData()
        },
        closeForm(){
            this.showForm = false
            this.loadData()
        },
        handleNew(){
            this.codvdevol = null
            this.showForm = false
            return this.$router.push('/varejolist/devolucao')
        },
        handleView(cod){
            this.crud = SysVars.crudView
            this.codvdevol = cod
            this.showForm = true
        },
        changeFiltros () {
            this.query.text = null
            this.loadData()
        },
        changeFiltroMes (filter, startDate, endDate) {

            this.query.after = startDate
            this.query.before = endDate
            this.query.text = null
            this.loadData()
        },
            changeFiltroTexto(value) {
            this.query.text = value.toUpperCase()
            this.query.after = null
            this.query.before = null
            this.loadData()
        }
    },
    computed:{
       pedvDevList(){
           return this.$store.getters.getvDevolList
       }
    },
    created(){
        this.loadData()
         this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        }
}
</script>

<template>
    <div>
        <div id="list" v-show="!showForm">
            <bar-list
            :refresh-button="true"
            :filter-month="true"
            :new-button="true"
            single-entity="Devolução/Venda"
            plural-entity="Devolução/Vendas"
            @new="handleNew"
            @search="changeFiltroTexto"
            @filter="changeFiltroMes"
            @refresh="loadData"
            title-search="Pesquise pelo código ou nome do cliente">
            </bar-list>
            <br>


            <div class="default-container mt-2" >
                <alert type="norecord" v-if="pedvDevList.length == 0"></alert>
                <div v-show="item.excluido =='N'" class="mainbox" v-for="(item, index) in pedvDevList" :key="index">
                    <div class="row pb-1">
                        <div class="col-md-1 col-2">
                            <span class="lbl-list"># Devolução</span><br>
                            <span class="mb-1">{{item.codvdevol}}</span>
                        </div>
                        <div class="col-md-2 col-2">
                            <span class="lbl-list">Data</span><br>
                            <span class="data-list">{{item.data | formatData}}</span>
                        </div>
                        <div class="col-md-2 col-4">
                            <span class="lbl-list">Operador</span><br>
                            <span class="mb-1">{{item.operador}}</span>
                        </div>
                        <div class="col-md-1 col-2">
                            <span class="lbl-list"> Pedido </span><br>
                            <span class="data-list">{{item.npedido}}</span>
                        </div>
                        <div class="col-md-2 col-4">
                            <span class="lbl-list">Valor Total</span><br>
                            <span class="data-list">R$ {{item.total | formatValue(2)}}</span>
                        </div>
                        <div class="col-md-2 col-4">
                            <span  class="lbl-list"> NF Devolução</span>
                            <span v-if="item.nf.serie" class="data-list">{{ item.nf.nf }} <span class="lbl-list" style="font-size:11px"> Serie</span> {{item.nf.serie}}</span>
                            <span v-else class="data-list">Não possui NF</span>
                            <span class="badge badge-danger" v-if="item.nf.enviar">Não Enviada</span>
                            <span class="badge badge-success" v-if="item.nf.autorizada">Autorizada</span>
                        </div>
                        <div class="col-md-2 col-4">
                            <div class="d-flex mt-2">
                                <v-button title="Visualizar" icon="fa-search" class="float-right" @click="handleView(item.codvdevol)"></v-button>
                                <v-button v-if="item.nf.enviar" title="Autorizar a NF de Devolução" icon="fa-rss-square" class="float-right" @click="handleAutorizaNF(item.nf.codnf)"></v-button>
                            </div>

                        </div>
                        <div class="col-md-12 col-12 ">
                            <span class="data-list" v-if="item.part">{{item.part.nome}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <DevolucaoForm v-if="showForm" :index="this.codvdevol" :crud="crud" @closeform="closeForm"/>
    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-devolucao-list.vue